<template>
  <div class="container money-tips-page">
    <div class="tips-box">
      <div class="tips-title">可用余额：</div>
      <div class="tips-p">当前账户可使用或退款的具有金额，不包括退款中和订单冻结金额。</div>
    </div>
    <div class="tips-box">
      <div class="tips-title">冻结金额：</div>
      <div class="tips-p">1、每次启动充电会预先扣除部分预付费金额，待订单完成后自动解冻返还至可用余额中。</div>
      <div class="tips-p">2、退款中的金额。</div>
    </div>
    <div class="tips-box">
      <div class="tips-title">余额：</div>
      <div class="tips-p">当前账户中的总金额，为可用余额和冻结金额的总和。</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'money-tips',
  data(){
    return{

    }
  },
  
}
</script>
<style lang="less">
.money-tips-page{
  padding: 0.17rem 0.20rem;
  background: #fff;
  .tips-box{
    margin-top: 0.40rem;
  }
  .tips-box:first-child{
    margin-top: 0;
  }
  .tips-title{
    font-size: 0.36rem;
    line-height: 0.50rem;
    color: #373A44;
  }
  .tips-p{
    margin-top: 0.20rem;
    font-size: 0.30rem;
    line-height: 0.42rem;
    color: #666;
  }
}
</style>